export const parseInfo = (info) => {
  const numbers = info.split(",");
  const roundIndex = parseInt(numbers[0], 10);
  const questionIndex = parseInt(numbers[1], 10);
  return {roundIndex: roundIndex, questionIndex: questionIndex}
}